<template>
    <canvas
        id="_flowCanvas"
        :width="width"
        :height="height"
        :class="{ 'cursor-hand': hoverId }"
    ></canvas>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
export default {
    props: {
        flowChartInfo: {
            type: Object,
            default: {},
        },

        ifJustShowMsg: {
            type: Boolean,
            default: true,
        },
        processInstanceId: {
            type: String,
            default: '',
        },
    },

    components: {},

    data() {
        return {
            canvas: null, //画布
            context: null, //画笔
            width: 1000, //画布尺寸
            height: 1000,
            space: 50, //画布边距
            startX: 0, //起始点多余空白尺寸
            startY: 0,
            timer: null,
            hoverId: '', //当前悬浮节点ID
            currentId: '', //当前选中的节点ID
            arrow: {
                //箭头相关参数
                angle: Math.PI / 6, //偏转角度
                length: 6, //线段长度
            },
            data: {},
        };
    },
    watch: {
        flowChartInfo: {
            handler(newVal) {
                this.data = newVal;
                this.CalculateSize();
                this.timer = setTimeout(() => {
                    this.LoadCanvas(true);
                }, 60);
            },
        },
        deep: true,
        immediate: true,
    },
    beforeDestroy() {
        clearTimeout(this.timer);
        this.timer = null;
        let _this = this;
        if (_this.SelectNode) {
            document
                .getElementById('_flowCanvas')
                .removeEventListener('click', _this.SelectNode, true);
        }
    },

    methods: {
        ...mapActions(['sa_SpringFlowableActionView_processChartNodeClick']),

        /**
         * 计算画布大小
         */
        CalculateSize() {
            this.startX = 0;
            this.startY = 0;

            let nodes = this.data.elements;
            let links = this.data.flows;
            let ax = 65535,
                ay = 65535,
                zx = 0,
                zy = 0;
            let ele = null;
            for (let i = 0; i < nodes.length; i++) {
                ele = nodes[i];
                ax = Math.min(ele.x, ax);
                ay = Math.min(ele.y, ay);
                zx = Math.max(ele.x + ele.width, zx);
                zy = Math.max(ele.y + ele.height, zy);
            }
            for (let i = 0; i < links.length; i++) {
                for (let j = 0; j < links[i].waypoints.length; j++) {
                    ele = links[i].waypoints[j];
                    ax = Math.min(ele.x, ax);
                    ay = Math.min(ele.y, ay);
                    zx = Math.max(ele.x, zx);
                    zy = Math.max(ele.y, zy);
                }
            }
            this.width = Math.max(zx - ax + this.space * 2, 700);
            this.height = Math.max(zy - ay + this.space * 2, 300);
            this.startX = ax;
            this.startY = ay;
        },
        /**
         * 加载画布
         * @param {第一次加载标识} flag
         */
        LoadCanvas(flag) {
            var canvas = document.getElementById('_flowCanvas');
            this.canvas = canvas;
            var context = canvas.getContext('2d');
            this.context = context;
            context.clearRect(0, 0, this.width, this.height);
            for (let i = 0; i < this.data.elements.length; i++) {
                this.DrawNode(context, this.data.elements[i], flag);
            }
            for (let i = 0; i < this.data.flows.length; i++) {
                this.DrawLine(context, this.data.flows[i]);
            }

            if (this.ifJustShowMsg) {
                //canvas鼠标悬浮效果：手势
                let elements = this.data.elements;
                let _this = this;
                canvas.onmousemove = function(e) {
                    let ox = e.offsetX,
                        oy = e.offsetY;
                    for (let i = 0; i < elements.length; i++) {
                        let nd = elements[i];
                        if (
                            ox > nd.x &&
                            ox < nd.x + nd.width &&
                            oy > nd.y &&
                            oy < nd.y + nd.height
                        ) {
                            _this.hoverId = nd.id;
                            return;
                        }
                    }
                    _this.hoverId = '';
                };
                //画布单击选中事件
                canvas.addEventListener('click', _this.SelectNode, true);
            }
        },

        SelectNode() {
            if (!this.hoverId) return;
            //重绘画板，显示当前选中节点的状态
            this.currentId = this.hoverId;
            this.LoadCanvas();
            //当hoverId不为空时，遍历数据源获取当前节点的信息 TODO
            this.ProcessChartNodeClick();
        },

        ProcessChartNodeClick() {
            this.sa_SpringFlowableActionView_processChartNodeClick({
                processInstanceId: this.processInstanceId,
                elementId: this.hoverId,
            })
                .then(res => {
                    if (res) {
                        axios
                            .all([
                                axios.get(
                                    `${this.$ysConfig.serviceProxy.BaseUrl}flowable/app/rest/admin/tasks/${res}`
                                ),
                                axios.get(
                                    `${this.$ysConfig.serviceProxy.BaseUrl}flowable/app/rest/admin/tasks/${res}/variables`
                                ),
                            ])
                            .then(
                                axios.spread((res1, res2) => {
                                    var nodeMsg = {};
                                    if (res1.data) {
                                        var temp_data = res1.data;
                                        nodeMsg.startTime = temp_data.startTime;
                                        nodeMsg.endTime = temp_data.endTime;
                                        nodeMsg.taskDefinitionKey = temp_data.taskDefinitionKey;
                                    }
                                    if (res2.data.data) {
                                        var variables_temp = res2.data.data;
                                        variables_temp.map(item => {
                                            var key = item.variable.name;
                                            var value = item.variable.value;
                                            nodeMsg[key] = value;
                                        });
                                    }
                                    this.$emit('processChartNodeMsg', nodeMsg, true);
                                })
                            );
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        /**
         * 绘制节点
         * @param {画笔} context
         * @param {节点} node
         * @param {第一次加载标识} flag
         */
        DrawNode(context, node, flag) {
            if (flag) {
                node.x = node.x - this.startX + this.space;
                node.y = node.y - this.startY + this.space;
            }

            //绘制圆弧矩形
            let color = node.type == 'SubProcess' ? 'green' : '#0061FF';
            this.FillRoundRect(context, node.x, node.y, node.width, node.height, 8, color);
            //当前选中的节点
            if (node.id == this.currentId) {
                context.strokeStyle = '#FFF';
                context.rect(node.x - 5, node.y - 5, node.width + 10, node.height + 10);
                context.stroke();
            }
            //标注内容
            if (node.name) {
                context.font = 'normal 12px arial';
                context.fillStyle = '#FFF';
                context.textAlign = 'center';
                context.fillText(node.name, node.x + node.width / 2, node.y + node.height / 2);
            }
        },
        /**
         * 绘制线
         * @param {画笔} context
         * @param {节点} 线
         */
        DrawLine(context, node) {
            let spaceX = this.space - this.startX,
                spaceY = this.space - this.startY;
            //绘制线条
            context.beginPath();
            let point = {};
            for (let i = 0; i < node.waypoints.length; i++) {
                point.x = node.waypoints[i].x + spaceX;
                point.y = node.waypoints[i].y + spaceY;
                if (i == 0) context.moveTo(point.x, point.y);
                else context.lineTo(point.x, point.y);
                //当线上有文字时
                if (node.name) {
                    //计算线段前两点的角度
                    //计算向量两点的真实位置
                    let d1 = node.waypoints[0];
                    let d2 = node.waypoints[1];
                    let p1 = { x: d1.x + spaceX, y: d1.y + spaceY };
                    let p2 = { x: d2.x + spaceX, y: d2.y + spaceY };
                    //计算向量角度
                    let alpha = 0; //结束线段的向量角度
                    if (p2.x == p1.x) {
                        //垂直时
                        alpha = p2.y - p1.y > 0 ? Math.PI / 2 : (Math.PI * 3) / 2;
                    } else if (p2.y == p1.y) {
                        //水平时
                        alpha = p2.x - p1.x > 0 ? 0 : Math.PI;
                    } else {
                        //当向量在第二、三像限时需要增加PI（补角的缘故）
                        let sa = p2.x - p1.x > 0 ? 0 : Math.PI;
                        alpha = Math.atan((p2.y - p1.y) / (p2.x - p1.x)) + sa;
                    }
                    //标注内容
                    context.save(); //保存画布状态
                    context.translate(p1.x, p1.y);
                    context.rotate(alpha);
                    context.font = 'normal 12px arial';
                    context.fillStyle = '#FFF';
                    context.textAlign = 'left';
                    context.fillText(node.name, 5, -5);
                    context.restore(); //恢复画布状态
                }
            }
            //计算向量两点的真实位置
            let d1 = node.waypoints[node.waypoints.length - 1];
            let d2 = node.waypoints[node.waypoints.length - 2];
            let p1 = { x: d1.x + spaceX, y: d1.y + spaceY };
            let p2 = { x: d2.x + spaceX, y: d2.y + spaceY };
            //计算向量角度
            let alpha = 0; //结束线段的向量角度
            if (p2.x == p1.x) {
                //垂直时
                alpha = p2.y - p1.y > 0 ? Math.PI / 2 : (Math.PI * 3) / 2;
            } else if (p2.y == p1.y) {
                //水平时
                alpha = p2.x - p1.x > 0 ? 0 : Math.PI;
            } else {
                //当向量在第二、三像限时需要增加PI（补角的缘故）
                alpha = Math.atan((p2.y - p1.y) / (p2.x - p1.x)) + p2.x - p1.x > 0 ? 0 : Math.PI;
            }
            //计算箭头坐标点
            let arrow = this.arrow;
            let beta1 = alpha + arrow.angle, //箭头上侧的偏移角度
                x1 = arrow.length * Math.cos(beta1) + p1.x,
                y1 = arrow.length * Math.sin(beta1) + p1.y,
                beta2 = alpha - arrow.angle, //箭头下侧的偏移角度
                x2 = arrow.length * Math.cos(beta2) + p1.x,
                y2 = arrow.length * Math.sin(beta2) + p1.y;
            //绘制箭头
            context.moveTo(x1, y1);
            context.lineTo(p1.x, p1.y);
            context.lineTo(x2, y2);
            //填充
            context.strokeStyle = '#FFF';
            context.stroke();
        },
        /**
         * ***************TOOL*************
         */
        /**该方法用来绘制一个有填充色的圆角矩形
         *@param cxt:canvas的上下文环境
         *@param x:左上角x轴坐标
         *@param y:左上角y轴坐标
         *@param width:矩形的宽度
         *@param height:矩形的高度
         *@param radius:圆的半径
         *@param fillColor:填充颜色
         **/
        FillRoundRect(cxt, x, y, width, height, radius, /*optional*/ fillColor) {
            //圆的直径必然要小于矩形的宽高
            if (2 * radius > width || 2 * radius > height) {
                return false;
            }

            cxt.save();
            cxt.translate(x, y);
            //绘制圆角矩形的各个边
            this.DrawRoundRectPath(cxt, width, height, radius);
            cxt.fillStyle = fillColor || '#000'; //若是给定了值就用给定的值否则给予默认值
            cxt.fill();
            cxt.restore();
        },

        /**该方法用来绘制圆角矩形
         *@param cxt:canvas的上下文环境
         *@param x:左上角x轴坐标
         *@param y:左上角y轴坐标
         *@param width:矩形的宽度
         *@param height:矩形的高度
         *@param radius:圆的半径
         *@param lineWidth:线条粗细
         *@param strokeColor:线条颜色
         **/
        DrawRoundRectPath(cxt, width, height, radius) {
            cxt.beginPath(0);
            //从右下角顺时针绘制，弧度从0到1/2PI
            cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);
            //矩形下边线
            cxt.lineTo(radius, height);
            //左下角圆弧，弧度从1/2PI到PI
            cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);
            //矩形左边线
            cxt.lineTo(0, radius);
            //左上角圆弧，弧度从PI到3/2PI
            cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);
            //上边线
            cxt.lineTo(width - radius, 0);
            //右上角圆弧
            cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);
            //右边线
            cxt.lineTo(width, height - radius);
            cxt.closePath();
        },
    },
};
</script>

<style lang="less" scoped>
.cursor-hand {
    cursor: pointer;
}
</style>
